__turbopack_context__.v({
  "pulse": "wishlist-component-module-scss-module__EyxEIq__pulse",
  "wishlist--carousel": "wishlist-component-module-scss-module__EyxEIq__wishlist--carousel",
  "wishlist--navigation-flyout": "wishlist-component-module-scss-module__EyxEIq__wishlist--navigation-flyout",
  "wishlist--pdp": "wishlist-component-module-scss-module__EyxEIq__wishlist--pdp",
  "wishlist--plp": "wishlist-component-module-scss-module__EyxEIq__wishlist--plp",
  "wishlist__desktop-wrapper": "wishlist-component-module-scss-module__EyxEIq__wishlist__desktop-wrapper",
  "wishlist__link": "wishlist-component-module-scss-module__EyxEIq__wishlist__link",
  "wishlist__mobile-wrapper": "wishlist-component-module-scss-module__EyxEIq__wishlist__mobile-wrapper",
  "wishlist__trigger": "wishlist-component-module-scss-module__EyxEIq__wishlist__trigger",
  "wishlist__trigger--loading": "wishlist-component-module-scss-module__EyxEIq__wishlist__trigger--loading",
});
